import _ from 'lodash'

export default {
  name: 'KCasGroup',
  componentName: 'KCasGroup',
  inject: ['KCasBox'],
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    context() {
      return this.KCasBox || {}
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  render() {
    return (
      <div class="km-cascade__group">
        <div class="km-cascade__group-title">{this.title}</div>
        <div class="km-cascade__group-content">
          {this.$slots.default}
        </div>
      </div>
    )
  },
  methods: {
    renderChildren() {
      const expandSlot = this.context.expandSlot
      const expandValue = this.context.expandValue
      const nodes = [...this.$slots.default]
      const expandIndex = _.findIndex(nodes, n => n.componentOptions.propsData.value === expandValue)
      if (expandIndex > -1 && expandSlot) {
        const insertIndex = _.ceil((expandIndex + 1) / 5) * 5
        nodes.splice(insertIndex, 0, expandSlot)
      }
      return nodes
    },
  },
}
